export enum OrderStatus {
    PLACED = "PLACED",
    FUNDS_RECEIVED = "FUNDS_RECEIVED",
    ACCEPTED = "ACCEPTED",
    FINISHED = "FINISHED",
    STARTED = "STARTED",
    REJECTED = "REJECTED",
    REFUNDED = "REFUNDED",
    REFUND_FAILED = "REFUND_FAILED",
    VOID = "VOID",
    READY_FOR_COLLECTION = "READY_FOR_COLLECTION",
    PARTIALLY_REFUNDED = "PARTIALLY_REFUNDED",
    PAYMENT_PROCESSING = "PAYMENT_PROCESSING",
    PROCESSING_REFUND = "PROCESSING_REFUND"
}